export const FIELDTYPE = { 
    TEXT: "Text",
    NUMBER: "Number",
    CURRENCY: "Currency",
    LONG_TEXT: "LongText",
    SINGLE_SELECT: "SingleSelect",
    DROP_DOWN: "Dropdown",
    MULTI_SELECT: "Multiselect",
    DATE: "Date",
    RADIO: "Radio",
    RICHTEXT: "RichText",
    DIVIDER: "Divider",
    FILE: "File"
}